const messages = {
  title: "Markedsføringssamtykker",
  required: "Påkrævet",
  answered: "✓ Besvaret",
  read: "Læst",
  notRead: "Ikke læst",
  alreadyAnswered: "Allerede besvaret",
  requiredQuestionsMustBeAccepted:
    "{count} påkrævede spørgsmål skal accepteres",
  pleaseAnswerQuestions: "Besvar venligst følgende spørgsmål:",
  iAccept: "Jeg accepterer",
  scrollToUnlock: "Rul til bunden for at låse op",
  fieldRequired: "Dette felt er påkrævet",
  scrollToContinue: "↓ Rul til bunden for at fortsætte",
  saving: "Gemmer...",
  saveConsents: "Gem samtykker",
  allRequiredAccepted: "✓ Alle påkrævede spørgsmål accepteret",
  requiredConsentsCompleted:
    "{completed}/{total} påkrævede samtykker udfyldt",
  selectConsentToView:
    "Vælg et samtykke på listen for at se indholdet",
  readAllContentFirst: "Læs alt indhold først: {names}",
  acceptAllRequiredIn: "Accepter alle påkrævede spørgsmål i: {names}",
  acceptAllBeforeSaving:
    "Accepter venligst alle påkrævede spørgsmål før du gemmer.",
  failedToSave: "Samtykker kunne ikke gemmes. Prøv venligst igen.",
  errorSaving:
    "Der opstod en fejl under gemning af samtykker. Prøv venligst igen.",
  failedToLoad: "Samtykker kunne ikke indlæses. Opdater venligst siden.",
  viewPdf: "Vis PDF",
  requiredConsentTitle: "Påkrævet samtykke",
  acceptAndContinue: "Accepter og fortsæt",
};

export default {
  messages,
};
